import React, { useEffect, useState } from "react";
import axios from "axios";

const Revoke_insp = () => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [activatingId, setActivatingId] = useState(null); // Track which button is loading

    useEffect(() => {
        fetchSuspendedFps();
    }, []);

    const fetchSuspendedFps = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${process.env.REACT_APP_URL}/api/load/getStatus`,
                { withCredentials: true }
            );
            setReportData(response.data.data || []);
        } catch (err) {
            setMessage("Failed to load data");
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const activateFps = async (fpsId) => {
        if (!window.confirm(`Are you sure you want to activate FPS: ${fpsId}?`)) {
            return;
        }

        setActivatingId(fpsId);
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_URL}/api/load/update`,
                { fpsIds: [fpsId] },
                { withCredentials: true }
            );

            setMessage(response.data.message || "FPS activated successfully!");
            fetchSuspendedFps(); // Refresh list
        } catch (err) {
            setMessage("Failed to activate FPS");
            console.error(err);
        } finally {
            setActivatingId(null);
        }
    };

    if (loading && reportData.length === 0) {
        return <div style={{ textAlign: "center", padding: "50px" }}>Loading...</div>;
    }

    return (
        <>
            <br /><br />

            <table align="center" width="90%" border="1" cellPadding="8" cellSpacing="0" style={{ borderCollapse: "collapse" }}>
                <thead>
                    <tr class="tableheader" >
                        <th colspan="7">REVOKE SUSPENDED FPS</th> </tr>
                    <tr class="tableheader">
                        <th>Sl.No</th>
                        <th>District</th>
                        <th>AFSO</th>
                        <th>FPS ID</th>
                        <th>FPS Name</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {reportData.length === 0 ? (
                        <tr>
                            <td colSpan="7" align="center" >
                                No suspended FPS found
                            </td>
                        </tr>
                    ) : (
                        reportData.map((fps, index) => (
                            <tr key={fps.fpsId} >
                                <td align="center">{index + 1}</td>
                                <td>{fps.distNameEn}</td>
                                <td>{fps.afsoNameEn}</td>
                                <td><strong>{fps.fpsId}</strong></td>
                                <td>{fps.fpsNameEn}</td>

                                {/* Status */}
                                <td align="center">
                                    <span style={{
                                        fontWeight: "bold",
                                        color: fps.fpsStatus === "S" ? "black" : "black"
                                    }}>
                                        {fps.fpsStatus === "S" ? "Suspended" : "Active"}
                                    </span>
                                </td>

                                {/* Action */}
                                <td align="center">
                                    {fps.fpsStatus === "S" ? (
                                        <button
                                            type="button"
                                            onClick={() => activateFps(fps.fpsId)}
                                            disabled={activatingId === fps.fpsId}
                                            class="button button2"
                                        >
                                            {activatingId === fps.fpsId ? "Activating..." : "Activate"}
                                        </button>
                                    ) : (
                                        <span style={{ color: "black", fontWeight: "bold" }}>Activated</span>
                                    )}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
                 {message && (
                <p style={{ color: message.includes("Failed") ? "red" : "black", textAlign: "center", fontWeight: "bold" }}>
                    {message}
                </p>
            )}
            </table>

            <br /><br />
        </>
    );
};

export default Revoke_insp;